<rma-navigation-header [showBackLink]="false" />

<mat-card *transloco="let t; prefix: 'subscriptions.billing.unsubscribe.support'" class="m-20 mx-auto max-w-3xl">
  <div class="flex flex-col gap-6 p-10">
    <div class="flex items-center">
      <h1 class="grow text-heading-2">{{ t('heading') }}</h1>
    </div>
    <img alt="" [src]="'subscriptions/offer-support.png' | staticImageUrl" />
    <div class="rounded-md border border-steel-20 p-6 text-center">
      <p class="pb-6 text-body" [innerHTML]="t('description')"></p>
      <a type="button" [href]="t('bookUrl')" mat-stroked-button target="_blank" color="primary">{{ t('book') }}</a>
    </div>
    <div class="flex justify-between border-t border-steel-20 pt-6">
      <a [routerLink]="'/manage-account/billing'" color="primary" mat-button>{{ t('cancel') }}</a>
      <a mat-flat-button color="primary" routerLink="/billing/unsubscribe-confirm">{{ t('downgrade') }}</a>
    </div>
  </div>
</mat-card>
